import React from 'react';

interface UserIconProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean; // наше кастомное поле
}

function UserIcon({ isActive = false, ...props }: UserIconProps) {
  return isActive ? (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6666 16.5V14.8333C14.6666 13.9493 14.3154 13.1014 13.6903 12.4763C13.0652 11.8512 12.2173 11.5 11.3333 11.5H4.66659C3.78253 11.5 2.93468 11.8512 2.30956 12.4763C1.68444 13.1014 1.33325 13.9493 1.33325 14.8333V16.5M11.3333 4.83333C11.3333 6.67428 9.84087 8.16667 7.99992 8.16667C6.15897 8.16667 4.66659 6.67428 4.66659 4.83333C4.66659 2.99238 6.15897 1.5 7.99992 1.5C9.84087 1.5 11.3333 2.99238 11.3333 4.83333Z" stroke="#FC8181" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.9666 16.5V14.8333C14.9666 13.9493 14.6154 13.1014 13.9903 12.4763C13.3652 11.8512 12.5174 11.5 11.6333 11.5H4.96663C4.08258 11.5 3.23473 11.8512 2.60961 12.4763C1.98449 13.1014 1.6333 13.9493 1.6333 14.8333V16.5M11.6333 4.83333C11.6333 6.67428 10.1409 8.16667 8.29997 8.16667C6.45902 8.16667 4.96663 6.67428 4.96663 4.83333C4.96663 2.99238 6.45902 1.5 8.29997 1.5C10.1409 1.5 11.6333 2.99238 11.6333 4.83333Z" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default UserIcon;
